var map = {
	"./en-US.json": 1549,
	"./fr-CA.json": 1550
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1548;


//////////////////
// WEBPACK FOOTER
// ./src/translations ^\.\/.*\.json$
// module id = 1548
// module chunks = 1